import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { verifyMobileUPILookupBasic } from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Data4 } from "../Data";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from "../../../context/ServiceContext";


const MoblieUPILookUpBasic = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [mobileData, setMobileData] = useState({});
  const [errors, setErrors] = useState({});
  const [profileData, setProfileData] = useState({});
  const [mobNumber, setMobNumber] = useState("");
  const { serviceName } = useService();

  // Fetch profile data on mount
  useEffect(() => { 
    const fetchProfileData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data:", error);
        showErrorToast("Failed to fetch profile data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  // Form validation
  const validateForm = (mobNumber) => {
    const errors = {};
  
    if (!mobNumber.trim()) {
      errors.mobNumber = "Mobile number is required.";
    }
      else if (!/^[1-9][0-9]{9}$/.test(mobNumber)) {
        errors.mobNumber = "Mobile number must be 10 digits and not start with 0.";
      }
      
  
    return errors;
  };
  

  const handleSubmit = async () => {
    const validationErrors = validateForm(mobNumber);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;
  
    try {
      setIsLoading(true);
  
      const response = await verifyMobileUPILookupBasic({
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile_number: mobNumber,
      });
  
      const statusCode = response?.status?.code;
      const statusMessage = response?.status?.message || response?.message;
  
      if (statusCode === 200) {
        const mobileDetails = response?.data;
  
        if (mobileDetails && typeof mobileDetails === "object") {
          setMobileData(mobileDetails);
          showSuccessToast(statusMessage || "Mobile To Name Verified successfully.");
          setErrors({});
        } else {
          showErrorToast("Mobile Name details are missing or in an unexpected format.");
        }
      } 
      else {
        // In all other error cases, show the message
        const errorMessage = response?.message || response?.data?.message || statusMessage || `Something went wrong. (code: ${statusCode})`;
        showErrorToast(errorMessage);
      }
  
    } catch (error) {
      console.error("Verify Mobile to Name Error:", error);
      showErrorToast("Failed to verify mobile details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading={serviceName} />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 justify-center md:ml-80 ml-0 p-4">
        
      <div className="col-span-2 md:col-span-6 flex justify-end">
  <Link
    to="/TestMaster"
    className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
  >
    <span>Go Back</span>
    <IoArrowBackCircleOutline size={24} />
  </Link>
</div>

        
        
        <InputWithLabel
          type="text"
          label="Mobile Number"
          placeholder="Enter Mobile No"
          maxLength="10"
          className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
          name="mobile_number"
          id="mobile_number"
          required={true}
          value={mobNumber}
          onChange={(e) => setMobNumber(e.target.value)}
          error={errors.mobNumber}
        />

        <div>
          <Button
            type="button"
            className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
            id="verifyMob"
            name="verifyMob"
            text="Verify"
            onClick={handleSubmit}
          />
        </div>
      </div>

      {mobileData && Object.keys(mobileData).length > 0 && (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4 my-4">

    {/* First Half - JSON Response */}
    <div className="bg-white border border-yellow-300 rounded-md shadow-lg p-4 overflow-auto max-h-96">
      <h2 className="text-lg font-semibold text-yellow-800 mb-3">Raw Response (JSON)</h2>
      <pre className="text-sm bg-gray-100 p-2 rounded-md">{JSON.stringify(mobileData, null, 2)}</pre>
    </div>

    {/* Second Half - Bank Details */}
    <div className="bg-white border border-green-300 rounded-md shadow-lg p-4">
      <h2 className="text-lg font-semibold text-green-800 mb-3">Mobile Details</h2>
      <p><strong>Full Name:</strong> {mobileData.mobile_linked_name || "N/A"}</p>
      <p><strong>VPA:</strong>{mobileData.vpa || "N/A"}</p>
    </div>

  </div>
)}




    </>
  );
};

export default MoblieUPILookUpBasic;
